export const DATA_LOADED = 'DATA_LOADED';
export const CURRENT_INFO_PANEL = 'CURRENT_INFO_PANEL';
export const CURRENT_HOTSPOT = 'CURRENT_HOTSPOT';
